import Vue from 'vue'

import { getUserData } from '@/core/auth/utils'
import { fetchOrderById, updateOrder } from '@/services/orderService'
import { $themeConfig } from '@themeConfig'

import { orderStore } from '../../gql/query'

const { GET_RESEND_DISHES, GET_HAS_DISH_RESEND } = orderStore()

export default {
    // GET Order для обновления блюд в заказе после добавления/удаления скидок
    fetchOrderDish({ commit }, id) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .get(`${$themeConfig.app.backUrl}/orders/${id}`)
                .then(response => {
                    commit('SET_DISHES', response.data.data)
                    resolve()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // Работа с блюдами ---------------------------------------------------->
    addDishInOrder(
        { commit, dispatch },
        { menu_item_id, price, count, dish_modifiers: dishModifiers, name }
    ) {
        const preparedDish = {
            menu_item_id,
            price,
            count,
            name,
            modifiers: dishModifiers.map(el => {
                return {
                    modifier_id: el.id,
                    price: el.price ? el.price : 0,
                    name: el.name ? el.name : undefined,
                    count: el.count,
                }
            }),
        }
        commit('ADD_DIRTY', 'dishes')
        commit('ADD_DISH_TO_ORDER', preparedDish)
        dispatch('recalcOrder').then(() => {
            dispatch('refreshDeliveryAvailability')
        })
    },

    deleteDish({ commit, dispatch }, { id }) {
        commit('DELETE_DISH_FROM_ORDER', { id })
        commit('ADD_DIRTY', 'dishes')
        dispatch('recalcOrder').then(() => {
            dispatch('refreshDeliveryAvailability')
        })
    },

    editDish({ commit, dispatch }, data) {
        commit('ADD_DIRTY', 'dishes')
        commit('UPDATE_DISH', data)
        dispatch('recalcOrder').then(() => {
            dispatch('refreshDeliveryAvailability')
        })
    },

    fetchHasResendDishes({ commit }, orderId) {
        return new Promise((resolve, reject) => {
            if (!orderId) {
                resolve(false)
            }

            Vue.axios
                .post(`${$themeConfig.app.gqlUrl}?refresh=true`, {
                    query: GET_HAS_DISH_RESEND,
                    variables: { orderId },
                })
                .then(response => {
                    commit(
                        'SET_HAS_RESEND_DISHES',
                        response.data.data?.dish_resend?.length > 0
                    )
                    resolve()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    fetchResendDishes({ commit }, orderId) {
        return new Promise((resolve, reject) => {
            if (!orderId) {
                resolve(false)
            }

            Vue.axios
                .post(`${$themeConfig.app.gqlUrl}?refresh=true`, {
                    query: GET_RESEND_DISHES,
                    variables: { orderId },
                })
                .then(response => {
                    commit('SET_RESEND_DISHES', response.data.data?.dish_resend)
                    resolve(response.data.data.dish_resend)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    async saveDishes({ getters, commit }, id) {
        if (!id) {
            throw new Error('Не указан ID заказа')
        }

        const changes = getters.getOrderDishesForSend
        if (!changes.dishes?.length) return

        const { user } = getUserData()
        const body = {
            ...changes,
            operator_id: user.id,
        }

        try {
            const response = await updateOrder(id, JSON.stringify(body))
            if (!response.data) throw new Error(response.error)

            const updatedOrder = await fetchOrderById(id)
            if (!updatedOrder.data) {
                throw new Error('Не удалось получить данные по заказу')
            }

            commit('SET_DISHES', {
                dishes: updatedOrder.data?.order?.dishes ?? [],
            })
            commit('RESET_DIRTY_DISHES')
            commit('REMOVE_DIRTY', 'dishes')
        } catch (error) {
            console.error('Ошибка при сохранении блюд:', error)
            throw error
        }
    },
}
